import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/service/request',
      name: 'service.request',
      component: () => import('./views/ServiceCallCreate.vue'),
    },
    {
      path: '/service/sent/:result',
      name: 'service.sent',
      component: () => import('./views/ServiceCallSent.vue'),
    },
    {
      path: '/service/list',
      name: 'service.list',
      component: () => import('./views/ServiceCallList.vue'),
    },
    {
      path: '/service/card/:id',
      name: 'service.card',
      component: () => import('./views/ServiceCallView.vue'),
    },
    {
      path: '/under/construction',
      name: 'under.construction',
      component: () => import('./views/UnderConstruction.vue'),
    },
    {
      path: '/settings/app',
      name: 'settings.app',
      component: () => import('./views/SettingsApp.vue'),
    },
  ],
});
